import { SPECIALIST_DETAILS } from 'constants/ActionTypes'

export const setSpecialistDetailsStep = (step) => ({
  type: SPECIALIST_DETAILS,
  step: step
})



// WEBPACK FOOTER //
// ./actions/Components.js